import {on} from "../jsbase/events";

var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('tt-id');
                return { id: rowId, $el: $rowElem, isFolder: !$rowElem.is('[data-catalog]') };
            },
            actions: [{
                name: 'ändern',
                classNames: 'dropdown-item',
                iconClass: 'bi-pencil-square',
                onClick: this.changeCatalog,
                isShown: (row) => !row.$el.is('.home'),
            }, {
                name: 'Katalog hinzufügen',
                classNames: 'dropdown-item',
                iconClass: 'bi-journal-plus',
                onClick: this.addCatalog,
                isShown: (row) => row.$el.is('.folder'),
            }, {
                name: 'Ordner hinzufügen',
                classNames: 'dropdown-item',
                iconClass: 'bi-folder-plus',
                onClick: this.addCatalogFolder,
                isShown: (row) => row.$el.is('.folder'),
            }, {
                name: 'Katalog/Ordner löschen',
                classNames: 'dropdown-item text-danger',
                iconClass: 'bi-trash',
                onClick: this.deleteCatalog,
                isEnabled: (row) => !row.$el.is('.home'),
            }],
        });
        $(this.el).on('onLoaded', this.refreshContextButtons);
    },

    methods: {
        refreshContextButtons(ev) {
            $(ev.currentTarget).find('.btn-context-click').get().forEach((el) => {
                on(el, 'click', (cev) => {
                    cev.preventDefault();
                    cev.stopPropagation();
                    var rowEl = $(cev.target).closest(this.selector);
                    this.menu.open(rowEl, cev);
                    return false;
                });
            });
        },
        addCatalog(row) {
            slidein.openUrl('/Devis/Default/CreateCatalogSlideIn?parentId=' + row.id);
        },
        addCatalogFolder(row) {
            slidein.openUrl('/Devis/Default/CreateCatalogFolderSlideIn?parentId=' + row.id);
        },
        changeCatalog(row) {
            if (row.id) {
                if (row.isFolder) {
                    slidein.openUrl('/Devis/Default/CreateCatalogFolderSlideIn/' + row.id);
                } else {
                    slidein.openUrl('/Devis/Default/CreateCatalogSlideIn/' + row.id);
                }
            }
        },
        deleteCatalog(row) {
            if (row.id) {
                messaging.askYesNo('Katalog löschen', 'Willst du diesen Katalog wirklich löschen?', function () {
                    var url = '/Devis/Default/DeleteCatalog/' + row.id;
                    connection.loadJson(url, null, function () {
                        row.$el.remove();
                        messaging.showGlobalMessage('success', null, 'Der Katalog wurde gelöscht.');
                        devis.catalogTreeTable.treetable("removeNode", response.id);
                    });
                });
            }
        },
    },

}
